import { render } from "./LazyImage.vue?vue&type=template&id=49478202&scoped=true"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"

import "./LazyImage.vue?vue&type=style&index=0&id=49478202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49478202"]])

export default __exports__